import React from "react";
import { Mail, Calendar, Phone, Shield, Users, Heart } from "lucide-react";
import { AppleLogo, AppLogo, QrScanner } from "../assets/images"; // Replace with actual imports
import { useNavigate } from "react-router-dom";

const BottomNavBar = () => {
  const navigate = useNavigate();
  return (
    <footer className="bg-white px-4 md:px-10 pt-8 md:pt-16">
      <div className="max-w-7xl mx-auto">
        {/* Logo + Text */}
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start mb-10 md:mb-16 space-y-6 md:space-y-0">
          <div className="flex-shrink-0">
            <img
              src={AppLogo}
              alt="Empfly Pulse Logo"
              className="w-32 md:w-44 h-auto object-contain"
            />
          </div>

          <div className="text-center md:text-left max-w-2xl">
            <h2 className="text-xl md:text-3xl font-bold text-green-800 mb-2 md:mb-3">
              Healing Beyond Medicine, Every Step of the Way.
            </h2>
            <p className="text-sm md:text-lg text-gray-700 leading-relaxed font-medium">
              AI + Expert-led recovery companion for breast cancer patients and
              caregivers.
            </p>
          </div>
        </div>

        <div className="w-full border-t border-gray-200 my-6" />

        {/* Grid Sections */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10 md:mb-16">
          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">Modules</h3>
            <ul className="space-y-3 text-base md:text-lg text-gray-700 font-medium">
              {[
                "Emotional Wellness",
                "Nutritional Recovery",
                "Physical Rehabilitation",
                "Caregiver Support",
                "Wellness Score System",
              ].map((item) => (
                <li key={item} className="flex items-center">
                  <Shield className="w-5 h-5 mr-2 text-green-600" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">Platform</h3>
            <ul className="space-y-3 text-base md:text-lg text-gray-700 font-medium">
              <li>Early Detection</li>
              <li>Doctor Dashboard</li>
              <li>Community</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">
              Contact & Support
            </h3>
            <ul className="space-y-3 text-base md:text-lg text-gray-700 font-medium">
              <li className="flex items-center">
                <Mail className="w-5 h-5 mr-2" />
                <a href="mailto:support@empfly.com">support@empfly.com</a>
              </li>
              <li className="flex items-center">
                <Calendar className="w-5 h-5 mr-2" />
                <a href="tel:9311440991">Helpline</a>
              </li>
              <li className="flex items-center">
                <Calendar className="w-5 h-5 mr-2" />
                <a href="tel:9311440991">Request a Demo</a>
              </li>
              <li className="flex items-center">
                <Phone className="w-5 h-5 mr-2" />
                <a href="tel:9311440991">Book a Call</a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">
              Join our community
            </h3>
            <ul className="space-y-4 text-base md:text-lg text-gray-700 font-medium">
              <li
                onClick={() => (window.location.href = "/privacy-policy")}
                className="flex items-center space-x-3"
              >
                <span className="w-9 h-9 bg-pink-100 rounded-full flex items-center justify-center">
                  <Shield className="w-5 h-5 text-pink-600" />
                </span>
                <span>Privacy Compliant</span>
              </li>
              <li className="flex items-center space-x-3">
                <span className="w-9 h-9 bg-pink-100 rounded-full flex items-center justify-center">
                  <Users className="w-5 h-5 text-pink-600" />
                </span>
                <span>Expert-Led</span>
              </li>
              <li className="flex items-center space-x-3">
                <span className="w-9 h-9 bg-pink-100 rounded-full flex items-center justify-center">
                  <Heart className="w-5 h-5 text-pink-600" />
                </span>
                <span>Human-In-the-loop</span>
              </li>
            </ul>
          </div>
        </div>

        {/* App Store + QR */}
        <div className="flex flex-col md:flex-row justify-center md:justify-between items-center mb-10 md:mb-16 gap-6">
          <div className="flex flex-wrap justify-center md:justify-start gap-6 items-center">
            {/* Apple */}
            <a
              href="https://apps.apple.com/in/app/pulse-by-empfly/id6755733224"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center bg-black text-white px-4 py-2 rounded-lg space-x-3 hover:opacity-90"
            >
              <img src={AppleLogo} alt="Apple" className="w-6 h-6" />
              <div className="text-left">
                <div className="text-xs md:text-sm">Download on the</div>
                <div className="text-sm md:text-base font-bold">App Store</div>
              </div>
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.empfly.pulse&hl=en"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center bg-black text-white px-4 py-3 rounded-lg space-x-3 hover:opacity-90"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Google Play"
                className="w-28 md:w-32 h-auto"
              />
            </a>

            {/* QR */}
            {/* <div className="flex flex-col items-center">
              <img
                src={QrScanner}
                alt="QR"
                className="w-16 md:w-20 h-16 md:h-20 object-contain"
              />
              <p className="text-xs md:text-sm text-green-700 mt-2 font-medium">
                Scan to get the app
              </p>
            </div> */}
          </div>
        </div>

        {/* Features */}
        <div className="flex flex-wrap justify-center gap-10 md:gap-16 mb-8">
          <div className="flex flex-col items-center text-center">
            <div
              onClick={() => (window.location.href = "/privacy-policy")}
              className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mb-2"
            >
              <Shield className="w-6 h-6 text-green-600" />
            </div>
            <div
              onClick={() => (window.location.href = "/privacy-policy")}
              className="text-sm md:text-base font-bold cursor-pointer"
            >
              Privacy Compliant
              <br />
              <span className="text-xs md:text-sm text-gray-600 font-normal">
                (DDPB 2022, HIPAA-ready)
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center text-center">
            <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mb-2">
              <Users className="w-6 h-6 text-green-600" />
            </div>
            <div className="text-sm md:text-base font-bold">Expert-Led</div>
          </div>

          <div className="flex flex-col items-center text-center">
            <div className="w-14 h-14 bg-pink-100 rounded-full flex items-center justify-center mb-2">
              <Heart className="w-6 h-6 text-pink-600" />
            </div>
            <div className="text-sm md:text-base font-bold">
              Human-in-the-loop
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="border-t pt-6 text-xs md:text-sm text-gray-600 text-center bg-green-50 py-4 rounded-t-lg font-medium">
          © 2025 Empfly Pulse. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default BottomNavBar;
